/* unplugin-vue-components disabled */import script from "./CardAverage.vue?vue&type=script&setup=true&lang=js"
export * from "./CardAverage.vue?vue&type=script&setup=true&lang=js"

import "./CardAverage.vue?vue&type=style&index=0&id=28252360&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28252360"]])

export default __exports__